<script lang="ts" setup>
import { useLocale } from '@composables/useLocale'
import { logInfo, scopedLogger } from '@lib/utils/logUtils'
import { useAppStore } from '@stores/app.store'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import BtnSignout from './actions/BtnSignout.vue'
import { useGtm } from '@composables/useGtm'

const log = scopedLogger('@components/FooterUserCard.vue')

const { t } = useLocale()
const router = useRouter()
const route = useRoute()
const name = ref<string>()
const path = ref<string>()
const store = useAppStore()
const { trackGoLogin } = useGtm()

const continueToIdentification = async () => {
  if (name.value !== 'identification') {
    trackGoLogin()
    logInfo(log, 'Continue to Identification')
    return await router.push({
      name: 'identification',
      query: { name: name.value }
    })
  }
}

watch(
  () => [route.name, route.path],
  ([toName, toPath]) => {
    name.value = toName as string
    path.value = toPath as string
  }
)

onMounted(() => {
  name.value = router.currentRoute.value.name as string
  path.value = router.currentRoute.value.path as string
})
</script>

<template>
  <!-- Attract, Identification, Anonymous welcome -->
  <div
    v-if="['attract', 'identification', 'anonymous-welcome'].includes(name as string)"
    v-ripple
    data-test="user-card--unlogged"
    class="bg-adk-main px-vh-32 gap-vh-16 flex w-full flex-col"
    @click="continueToIdentification()"
  >
    <div class="gap-vh-8 flex flex-col text-center">
      <p class="text-h3 font-bold">{{ t('inicia_sesion_con_tu_qr') }}</p>
      <p class="text-large">{{ t('Suma_puntos_y_canjealos_por_productos') }}</p>
    </div>
    <img
      src="/images/user/user-card.svg"
      alt="user-card"
      class="m-auto h-[calc(144*var(--vh))] w-auto"
    />
  </div>

  <!-- Only when coupons page -->
  <div
    v-else-if="name === 'aop-coupon'"
    class="bg-adk-main p-vh-32 gap-vh-8 flex min-h-full w-full flex-col justify-end rounded-t-xl pb-0"
  >
    <img src="/images/user/user-card.svg" alt="user-card" class="h-[calc(80*var(--vh))] w-auto" />
    <div class="text-center">
      <p class="text-small">{{ t('tienes_un_cupon') }}</p>
      <p class="text-large font-bold">{{ t('escanealo_aqui') }}</p>
    </div>
    <img
      src="/images/icons/chevron.svg"
      alt="chevron"
      class="h-vh-32 mb-vh-8 w-auto cursor-pointer"
    />
  </div>
  <!-- User logged -->
  <div
    v-else-if="store.user"
    v-ripple
    data-test="user-card--logged"
    class="border-adk-secondaryGrey py-vh-24 px-vw-32 gap-vh-8 flex h-[calc(216*var(--vh))] w-full flex-col justify-center rounded-t-xl border text-center"
  >
    <img
      src="/images/icons/logout.svg"
      alt="logout"
      class="h-vh-40 mb-vh-8 w-full cursor-pointer"
    />
    <p class="text-large font-bold">{{ store.user.name }}</p>
    <BtnSignout />
  </div>
  <!-- By default unlogged -->
  <div
    v-else
    v-ripple
    data-test="user-card--unlogged"
    class="bg-adk-main p-vh-32 gap-vh-8 flex min-h-full w-full flex-col rounded-t-xl pb-0"
    @click="continueToIdentification()"
  >
    <img src="/images/user/user-card.svg" alt="user-card" class="h-[calc(80*var(--vh))] w-auto" />
    <div class="text-center">
      <p class="text-small">{{ t('Escanea_tu_QR_para') }}</p>
      <p class="text-large font-bold">{{ t('iniciar_sesion') }}</p>
    </div>
    <img
      src="/images/icons/chevron.svg"
      alt="chevron"
      class="h-vh-32 mb-vh-8 w-auto cursor-pointer"
    />
  </div>
</template>
